/**
 * Labstep
 */

import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import Modal from 'labstep-web/core/Modal';
import { ModalWizardHeaderSteps } from 'labstep-web/core/Modal/Wizard/Header/Steps';
import type React from 'react';
import styles from './styles.module.scss';
import type { IModalWizardHeaderProps } from './types';

export const ModalWizardHeader: React.FC<IModalWizardHeaderProps> = ({
  steps,
  title,
  activeStepIndex,
  mode,
}) => (
  <Mobile>
    {({ match }) => (
      <Modal.Header className={styles.header}>
        <div className={styles.title}>{title}</div>
        {match ? null : (
          <ModalWizardHeaderSteps
            steps={steps}
            activeStepIndex={activeStepIndex}
            mode={mode}
          />
        )}
        {<div /> /** Empty div for styling */}
      </Modal.Header>
    )}
  </Mobile>
);
